import Choices from 'choices.js';

const configChoices = {
  silent: false,
  items: [],
  choices: [],
  renderChoiceLimit: -1,
  maxItemCount: -1,
  closeDropdownOnSelect: 'auto',
  singleModeForMultiSelect: false,
  addChoices: false,
  addItems: true,
  addItemFilter: (value: string | null | undefined) => !!value && value !== '',
  removeItems: false,
  removeItemButton: false,
  removeItemButtonAlignLeft: false,
  editItems: false,
  allowHTML: false,
  allowHtmlUserInput: false,
  duplicateItemsAllowed: true,
  delimiter: ',',
  paste: true,
  searchEnabled: false,
  searchChoices: false,
  searchFloor: 1,
  searchResultLimit: 4,
  searchFields: ['label', 'value'],
  position: 'bottom',
  resetScrollPosition: true,
  shouldSort: false,
  shouldSortItems: false,
  shadowRoot: null,
  placeholder: true,
  placeholderValue: null,
  searchPlaceholderValue: null,
  prependValue: null,
  appendValue: null,
  renderSelectedChoices: 'always',
  loadingText: 'Loading...',
  noResultsText: 'No results found',
  noChoicesText: 'No choices to choose from',
  itemSelectText: '',
  uniqueItemText: 'Only unique values can be added',
  customAddItemText: 'Only values that meet specific conditions can be added',
  classNames: {
    containerOuter: ['choices'],
    containerInner: ['choices__inner'],
    input: ['choices__input'],
    inputCloned: ['choices__input--cloned'],
    list: ['choices__list'],
    listItems: ['choices__list--multiple'],
    listSingle: ['choices__list--single'],
    listDropdown: ['choices__list--dropdown'],
    item: ['choices__item', 'common-text-300', 'text-color-blue-low'],
    itemSelectable: ['choices__item--selectable', 'text-capitalize'],
    itemDisabled: ['choices__item--disabled'],
    itemChoice: ['choices__item--choice'],
    description: ['choices__description'],
    placeholder: ['choices__placeholder'],
    group: ['choices__group'],
    groupHeading: ['choices__heading'],
    button: ['choices__button'],
    activeState: ['is-active'],
    focusState: ['is-focused'],
    openState: ['is-open'],
    disabledState: ['is-disabled'],
    highlightedState: ['is-highlighted'],
    selectedState: ['is-selected'],
    flippedState: ['is-flipped'],
    loadingState: ['is-loading'],
    notice: ['choices__notice'],
    addChoice: ['choices__item--selectable', 'add-choice'],
    noResults: ['has-no-results'],
    noChoices: ['has-no-choices'],
  },
  fuseOptions: {
    includeScore: false,
  },
  labelId: '',
  callbackOnInit: null,
  callbackOnCreateTemplates: null,
  appendGroupInSearch: false,
};

export const initCustomSelect = (sel: HTMLSelectElement) => {
  // @ts-ignore
  // eslint-disable-next-line no-param-reassign,no-underscore-dangle
  sel._choicesInstance = new Choices(sel, configChoices);
  sel.addEventListener('change', (e: Event) => {
    // @ts-ignore
    if (e.detail !== null) {
      if (sel.parentNode?.parentNode) {
        // @ts-ignore
        if (e.detail.value !== '') {
          (sel.parentNode.parentNode as HTMLElement).classList.add('is-filled');
          if (sel.parentNode.parentNode.parentNode) {
            (sel.parentNode.parentNode.parentNode as HTMLElement).classList.add('is-filled');
          }
        } else {
          (sel.parentNode.parentNode as HTMLElement).classList.remove('is-filled');
          if (sel.parentNode.parentNode.parentNode) {
            (sel.parentNode.parentNode.parentNode as HTMLElement).classList.remove('is-filled');
          }
        }
      }
    }
  });
};

export const initAll = (wrapper: HTMLElement) => {
  const selects = wrapper.querySelectorAll('.form-custom-select');
  selects.forEach((sel) => {
    initCustomSelect(sel as HTMLSelectElement);
  });
};
